import pino from 'pino';


const formatTime = (timestamp) => {
  const date = new Date(timestamp || Date.now());

  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');
  const ms = String(date.getMilliseconds()).padStart(3, '0');

  return `${hh}:${mm}:${ss}.${ms}`;
};

const getStackTrace = (depthLevel = 0) => {
  const error = new Error('');
  const stackTrace = error.stack || error.stacktrace || '';

  let stack = stackTrace.split('\n');

  const ignoredLines = stack[0] === 'Error' ? 3 : 2;
  stack = stack.slice(ignoredLines + depthLevel);

  return {
    location: `\n\n${stack[0]}\n`,
    stack: `\n\n${stack.join('\n')}\n`,
  };
};

const createLogger = (type = 'log') => (args = {}) => {
  const { time, msg = '', level, ...rest } = args;

  const dateTime = formatTime(time);
  const { location, stack } = getStackTrace(2);

  let stackMessage = stack;
  if (['debug', 'info', 'log'].includes(type)) {
    stackMessage = location;
  }

  const lines = [];
  lines.push(`[${dateTime}] ${msg}`);

  if (Object.keys(rest).length) {
    lines.push('\n');
    lines.push(rest);
  }

  lines.push(stackMessage);

  // eslint-disable-next-line no-console
  console[type](...lines);
};


export default pino({
  browser: {
    write: {
      log: () => {
        const { stack } = getStackTrace();
        const dateTime = formatTime();
        const msg = 'Unsupported method "log". Use "console.log" instead.';

        // eslint-disable-next-line no-console
        console.error(`[${dateTime}] `, msg, stack);
      },
      trace: createLogger('trace'),
      debug: createLogger('debug'),
      info: createLogger('info'),
      warn: createLogger('warn'),
      error: createLogger('error'),
    },
  },
  level: 'trace',
});
